// extracted by mini-css-extract-plugin
export default {"cls1":"AccountMenu-cls1__e230c279e0c12204ac43","cls2":"AccountMenu-cls2___c8b461cb4c906851c23 AccountMenu-cls1__e230c279e0c12204ac43"};